"use client";
import { Animated } from "../animated";
import { Banner } from "./banner";
import { TheChallengeSolution } from "./the-challenge-solution";
import { CTA } from "./cta";
import { RealWorldSolutionsSection } from "../nsw-water-compliance/real-world-solutions";
import { SectionSeparator } from "../shared";
import { HowItWorks } from "./how-it-works";

export default function VMapVegetationMonitoringPage() {
  return (
    <Animated>
      <Banner />
      <TheChallengeSolution />
      <SectionSeparator
        imageUrl="/images/vmap-2.webp"
        dataSpeed="0.05"
        overlayClassName="from-black/20 to-black/40"
      />
      <HowItWorks />
      <SectionSeparator
        imageUrl="/images/vmap-map.webp"
        overlayClassName="from-black/10 to-black/30"
        imageClassName="w-full"
      />
      <RealWorldSolutionsSection />
      <CTA />
    </Animated>
  );
}
